import { Route, AppId, createPageRoute } from '@lumapps/router';

export const formsAnalyticsRoute: Route = createPageRoute({
    slug: 'analytics/forms',
    id: 'forms-analytics',
    appId: AppId.backOffice,
});
